import { render, staticRenderFns } from "./Asignacion.vue?vue&type=template&id=3c9810b5&"
import script from "./Asignacion.vue?vue&type=script&lang=js&"
export * from "./Asignacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports